export const spaceKeyCode = 32;
